const StratePartenaires = {
    init() {
        const partenaires = $('.strate-partenaires');
        if (partenaires.length > 0) {
            partenaires.each(
                function () {
                    const partenaireBody = $(this).find('.strate-partenaires__body');
                    const descriptionWrapper = $(this).find('.partenaires-cards__description');

                    if(partenaireBody) {
                        StratePartenaires.handleSlider(partenaireBody);
                        $(window).resize(
                            function () {
                                StratePartenaires.handleSlider(partenaireBody);
                            }
                        );
                    }

                    if(!!descriptionWrapper.length && $(window).width() > 768) {
                        StratePartenaires.injectMorOrLessAction(descriptionWrapper);
                    }
                }
            );
        }
    },

    injectMorOrLessAction(descriptionBlocks) {
        descriptionBlocks.each(
            function () {
                const description = $(this).find('.partenaires-cards__description--content');
                const ctaMoreOrLessWrapper = $(this).find('.wrapper-cta-more-less');
                const ctaMore = ctaMoreOrLessWrapper.find('.more');
                const ctaLess = ctaMoreOrLessWrapper.find('.less');

                if (description.height() > 100) {
                    description.css('max-height', '100px');
                    ctaMoreOrLessWrapper.css('display', 'block');
                    ctaLess.hide();

                    ctaMore.click(
                        function () {
                            $(this).hide();
                            ctaLess.css('display', 'inline');
                            description.css('max-height', description.prop('scrollHeight'));
                        }
                    );

                    ctaLess.click(
                        function () {
                            $(this).hide();
                            ctaMore.css('display', 'inline');
                            description.css('max-height', '100px');
                        }
                    );
                }
            }
        )
    },

    handleSlider(sliderWrapper) {
        if ($(window).width() < 768) {
            if (!sliderWrapper.hasClass('owl-carousel')) {
                sliderWrapper.addClass('owl-carousel');
                StratePartenaires.initSlider(sliderWrapper);
            }
        } else if (sliderWrapper.hasClass('owl-carousel')) {
            sliderWrapper.trigger('destroy.owl.carousel');
            sliderWrapper.removeClass('owl-carousel');
        }
    },

    initSlider(sliderWrapper) {
        const onInitialized = () => {
            const descriptions = sliderWrapper.find('.partenaires-cards__description');
            if (!!descriptions.length) {
                StratePartenaires.injectMorOrLessAction(descriptions);
            }
        }

        sliderWrapper.owlCarousel(
            {
                center: false,
                margin: 20,
                items: 1,
                loop: true,
                nav: false,
                dots: true,
                stagePadding: 0,
                autoWidth: false,
                responsive: {
                    480: {
                        center: false,
                        margin: 20,
                        items: 2,
                        loop: true,
                        nav: false,
                        dots: true,
                        stagePadding: 0,
                        autoWidth: false,
                    },
                },
                onInitialized,
            }
        );
    },
};
export default StratePartenaires;
